import React from "react";
import { useFilterBarValue } from "Context";
import { IFilterConfig } from "Models";
import { DropdownFilterWrapper } from "./DropdownFilterWrapper";
import { Calendar } from "@progress/kendo-react-dateinputs";
import { formatDateToUtc } from "Utilities";

export const FilterBarDatePicker: React.FC<IFilterConfig> = ({
  name,
  inputProps,
  ...filterProps
}) => {
  const [selectedDate, setSelectedDate] = useFilterBarValue(name);
  var dateValue = selectedDate ? new Date(selectedDate) : undefined;

  return (
    <DropdownFilterWrapper name={name} {...filterProps}>
      <Calendar
        focusedDate={dateValue}
        value={dateValue}
        onChange={(e) => setSelectedDate(formatDateToUtc(e.value, true))}
        className="popup-calendar"
      />
    </DropdownFilterWrapper>
  );
};
